module.exports = __webpack_public_path__ + "img/Krapez Dusan.jpg";